/* Built In Imports */
// import NextLink from "next/link";
import Link from 'next/link';
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Center, Flex, Image, Text } from '@chakra-ui/react';
import { VscChevronLeft } from 'react-icons/vsc';

/* Internal Imports */
/* Components */
import config from '@config';
import LiteYouTubeEmbed from '@ihs/components/Embeds/YoutubeEmbed';
import ShareIcon from '@ihs/components/Icons/ShareIcon';
import {
  ArticleIcon,
  SpeakerIcon,
  VideoIcon,
} from '@ihs/components/Icons/wisdomCardIcon';
import Article from '@ihs/components/UI/PoemAudioVideo';
import { getEmbedUrl } from '@ihs/components/Utility/utils';

/* Services */
/* Styles */

/**
 * Renders the Banner component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Banner component
 */

const ArticleBanner = ({ sectionContent, pageData, type }) => {
  const date = new Date(pageData?.childrens?.[0].createdAt);
  const iconToShow = {
    article: (
      <ArticleIcon
        pt="0"
        width={{ base: '23px', md: '36px' }}
        height={{ base: '23px', md: '36px' }}
        viewBox={{ base: '0 0 23px 23px', md: '0 0 36px 36px' }}
      />
    ),
    audio: <SpeakerIcon />,
    video: (
      <VideoIcon
        pt="0"
        width={{ base: '23px', md: '36px' }}
        height={{ base: '23px', md: '36px' }}
        viewBox={{ base: '0 0 23px 23px', md: '0 0 36px 36px' }}
      />
    ),
  };
  const router = useRouter();
  const url = router.asPath;
  const VID_REGEX =
    /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  return (
    <Box w="full" bg="#fff" pos="relative" maxW="1330px" mx="auto" h="100%">
      <Box
        mx="auto"
        px={{ base: '0', md: '16px', xl: '0' }}
        maxW="1330px"
        w="100%"
        backgroundSize={{
          base: '100% 213px',
          md: '100% 400px',
          lg: '100% 551px',
        }}
        bgImg={{
          base: `${config.imgPath}/d/46272/1702378618-banner-bg_mobile.jpg`,
          md: `${config.imgPath}/d/46272/1702373360-blog_banner.jpg`,
        }}
        bgRepeat="no-repeat"
        bgPos={{ base: 'top', lg: 'top center' }}
        paddingTop={{ base: '25px', md: '48px' }}
      >
        <Flex
          alignSelf={{ base: 'center', md: 'flex-start' }}
          width="100%"
          // position="absolute"
          className="ArticleBannerAbsolute"
          // left={{ base: '0px', md: 'unset', lg: '60px' }}
          maxW={{ base: '100%', md: '670px' }}
          mx="auto"
          right={{ base: '0', md: 'auto', lg: '60px' }}
          // zIndex={{ base: "15px", md: "10" }}
          padding={{ base: '0 15px', md: '0' }}
          justifyContent="space-between"
          h="100%"
        >
          <Flex>
            {/* <NextLink href="/isha-home-school/resources" legacyBehavior passHref> */}
            <Link
              href="/isha-home-school/resources"
              _hover={{ boxShadow: 'none' }}
              _focus={{ boxShadow: 'none' }}
            >
              <Center
                color="#353535"
                fontSize={{ base: '26.44px', md: '33px' }}
                fontWeight="light"
                borderRadius="50%"
                background={`url(${config.imgPath}/d/46272/1701245566-arrow-left.svg)`}
                bgSize="cover"
                bgRepeat="no-repeat"
                w={{ base: '38.324px', md: '62.324px' }}
                h={{ base: '37.091px', md: '60.32px' }}
                _hover={{
                  color: '#fff',
                  bgImage: `url(${config.imgPath}/d/46272/1701325617-left-hover-bg.svg)`,
                }}
                cursor="pointer"
              >
                {/* <Icon width={{ base: "26.44px", md: "43px" }} height={{ base: "26.44px", md: "43px" }} viewBox="0 0 44 43" fill="none" _hover={{ fill: "#fff", color: "white" }}> */}
                <VscChevronLeft />
                {/* </Icon> */}
              </Center>
            </Link>
            {/* </NextLink> */}
            <Flex
              alignItems="center"
              gridGap="7px"
              w="auto"
              height="auto"
              p={{ base: '0px 0 0 8.68px', md: '0px 0 0 28.68px' }}
              // bg="#DB3030"
              borderRadius="29px"
              justifyContent="center"
            >
              <Text
                as="span"
                fontFamily="FedraSansStd-Book"
                fontStyle="normal"
                fontWeight="500"
              >
                {iconToShow[pageData?.parentContent?.title?.toLowerCase()]}
              </Text>
              <Text
                color="#3B444B"
                fontFamily="Zilla Slab"
                fontSize={{ base: '20px', md: '28px' }}
                fontStyle="normal"
                fontWeight="400"
                ml={{ base: '9px', md: '19px' }}
                lineHeight={{ base: '24px', md: '24px' }}
              >
                {`${date.getDate()} ${date.toLocaleString('default', {
                  month: 'short',
                })} ${date.getFullYear()}`}
                {sectionContent?.childrens[0]?.videoLength[0].value
                  ? ` | ${sectionContent?.childrens[0]?.videoLength[0].value}`
                  : ''}
              </Text>
            </Flex>
          </Flex>
          <Box display="flex">
            <ShareIcon url={url} />
          </Box>
        </Flex>
        <Box
          w={{ base: '100%', md: '100%', lg: '80%' }}
          maxW="670px"
          margin={{ base: '0', md: '0 auto' }}
        >
          <Box
            w="100%"
            padding={{
              base: '25.91px 16px 0px',
              md: '40.68px 16px 0px 16px',
              lg: '48.68px 0 0px',
            }}
          >
            <Box w="100%" height="auto" maxW={670} mx="auto">
              {pageData?.title && (
                <Text
                  fontSize={{ base: '24px', md: '42px' }}
                  as="h1"
                  m={0}
                  mb={{ base: '18.95px', md: '35px' }}
                  lineHeight={{
                    base: '24px',
                    md: '39px',
                  }}
                  color="#3B444B"
                  maxW={{ base: 'none', md: '652px', lg: '652px' }}
                  fontFamily="Zilla Slab"
                  fontWeight="600"
                >
                  {pageData?.title}
                </Text>
              )}
              {pageData?.summary && (
                <Text
                  fontFamily="FedraSerifAStdBook"
                  fontStyle="normal"
                  fontWeight="350"
                  fontSize={{ base: 'body2', md: '20px' }}
                  lineHeight={{ base: '26px', md: '32px' }}
                  mt={'20px'}
                  color="bodyText.color3"
                >
                  {pageData.summary}
                </Text>
              )}
              <style jsx global>
                {`
                  @media (max-width: 768px) {
                    .topBannerBlogEmbed iframe {
                      height: 202px;
                    }
                  }
                `}
              </style>
            </Box>
          </Box>
        </Box>
        <Box
          position="relative"
          maxW="670px"
          w="100%"
          zIndex={5}
          mx="auto"
          px={{ base: '16px', md: '0', lg: '0' }}
          h="auto"
          minH={{ base: '206px', sm: '300px', md: '350px', lg: '391px' }}
        >
          <Box w="100%">
            {pageData?.parentContent?.title?.toLowerCase() === 'audio' && (
              <Article
                type={pageData?.parentContent?.title?.toLowerCase()}
                articleData={pageData?.childrens?.[0]}
                // isLikeBookmarkVisible={isLikeBookmarkVisible}
                // updateCards={updateCards}
                // language={language}
              />
            )}
            {pageData?.parentContent?.title?.toLowerCase() === 'article' && (
              <Image
                placeholder="blur"
                quality={100}
                fill
                // sizes="100vw"
                style={{
                  objectFit: 'cover',
                }}
                // loader="https://static.sadhguru.org/d/46272/1682095879-white-texture-final.png"
                h="100%"
                // priority
                // blurDataURL={imageLoader(pageData?.heroImage?.url)}
                // blurDataURL={`${pageData?.heroImage?.url}?q=20`}
                blurDataURL="https://static.sadhguru.org/d/46272/1682095879-white-texture-final.png"
                w="100%"
                alt={pageData?.childrens[0]?.heroImage[0].value.alt}
                src={pageData?.childrens[0]?.heroImage[0].value.url}
              />
            )}
            {pageData?.parentContent?.title?.toLowerCase() === 'video' && (
              <Box
                maxW="100%"
                w="full"
                h={{
                  base: '206px',
                  sm: '300px',
                  md: '350px',
                  lg: '418px',
                }}
                className="topBannerBlogEmbed"
              >
                <LiteYouTubeEmbed
                  // poster={pageData?.childrens[0]?.heroImage[0].value.alt}
                  id={getEmbedUrl(
                    pageData?.childrens[0].mediaUrl[0].value[0].embedUrl
                  )}
                  embedUrl={getEmbedUrl(
                    pageData?.childrens[0].mediaUrl[0].value[0].embedUrl
                  )}
                  cookie
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ArticleBanner;
